import { FINANCE_SERVER } from '@/constants/domains'
import VueCookie from 'vue-cookie'
const axios = require('axios')

export default {
  getTypeServiceProject () {
    const instCred = axios.create({
      baseURL: FINANCE_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.get('typeServicesProject')
  }
}



// WEBPACK FOOTER //
// ./src/api/TypeServiceProject/api.js